export default __webpack_public_path__ + "static/media/copy-icon.f865e67d.svg";